// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__uZO8o","amount":"TableRow_amount__CTkF0","company":"TableRow_company__TWyR0"};